import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicCheckbox, BaasicModal, BaasicFieldDropdown } from 'core/components';
import { Content } from 'core/layouts';
import { toDate, uuid } from "core/utils";
import { FacilityOrderTemplateMissingDocumentNoteModal } from "application/facility-order/components";

function FacilityMissingDocsEditTemplate({ facilityMissingDocsEditViewStore }) {
    const {
        contentLoading,
        item,
        setIncludeInDocReqEmail,
        isCurrent,
        form,
        missingDocumentStore,
        facilityOrderTemplateMissingDocumentNoteModal,
        openFacilityOrderTemplateMissingDocumentNoteModal,
        openPatientMissingDocsPreview,
        isTemplatePreview,
        showItems,
        changeItemVisibility,
        isItemVisible,
        eligibilityStatus,
        inactiveReason
    } = facilityMissingDocsEditViewStore;

    const tagRender = (tagData, li) => React.cloneElement(li, { children: <span key={uuid()} onClick={() => openFacilityOrderTemplateMissingDocumentNoteModal(tagData.data[0])}>{tagData.data[0].name}</span> });

    return (
        <Content loading={contentLoading} >
            <div className='card--patient'>
                <div className='card--patient__header'>
                    <div className='u-flex--default'>
                        {!isTemplatePreview &&
                            <a className="u-mar--right--sml u-flex--default" onClick={() => openPatientMissingDocsPreview()}> 
                                <i className="u-icon u-icon--lrg u-icon--persons u-mar--right--tny"></i>
                                <u>
                                    {item.patient.lastName && `${item.patient.lastName}`}
                                    {item.patient.lastName && item.patient.firstName && ', '}
                                    {item.patient.firstName && `${item.patient.firstName}`}
                                </u>
                            </a>
                        }
                        <label className="u-mar--right--sml"> {item.subCategory.name}</label>
                        <label> {item.templateId}</label>
                    </div>
                </div>
                <div className='card--patient__body'>
                    <table className="table--secondary w--100">
                        <thead>
                            <tr>
                                <th colSpan="4" className="type--left">

                                    <div className="u-flex--default u-mar--bottom--sml">
                                        {!isTemplatePreview &&
                                            <label className='type--color--opaque u-mar--right--tny'>DOS:</label>
                                        }
                                        <label className="type--wgt--med">{toDate(item.facilityOrder.dateOfService)}</label>
                                        {!isTemplatePreview && (
                                            isCurrent ?
                                                <div className="status status--tny status--success u-display--ib u-mar--left--tny">CURRENT</div>
                                                :
                                                <div className="status status--tny status--disabled u-display--ib u-mar--left--tny">PAST</div>
                                        )}
                                        <div className="u-flex u-flex--default u-align--h--right">
                                            {inactiveReason && <div className="status status--warning status--sml u-mar--right--tny">{inactiveReason.name}</div>}
                                            <div className="status status--blue status--sml u-mar--right--tny">{item.clinicalStatus ? item.clinicalStatus.name : eligibilityStatus ? eligibilityStatus.name : "None"}</div>
                                            {!isCurrent &&
                                                <BasicCheckbox
                                                    id={item.id + "includeInDocReqEmail"}
                                                    checked={item.includeInDocReqEmail}
                                                    onChange={(e) => setIncludeInDocReqEmail(e.target.checked)}
                                                />
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form__group col col-lrg-12">
                                            <BaasicFieldDropdown field={form.$('facilityOrderTemplateMissingDocuments')} store={missingDocumentStore} multi={true} tagRender={tagRender} autoClose={true} />
                                        </div>
                                    </div>

                                    {showItems && <a className={`u-anchor--sml--underline ${isItemVisible ? "u-mar--top--med" : ""}`} onClick={() => changeItemVisibility()}> {isItemVisible ? "Show less" : "Show all"}</a>}
                                </th>
                            </tr>
                        </thead>
                        {showItems &&
                            <tbody>
                                {isItemVisible && item.facilityOrderTemplateItems.map((facilityOrderTemplateItem) => {
                                    return (
                                        <tr key={facilityOrderTemplateItem.id}>
                                            <td>
                                                {facilityOrderTemplateItem.product && facilityOrderTemplateItem.product.description}
                                            </td>
                                            <td>
                                                {facilityOrderTemplateItem.product && facilityOrderTemplateItem.product.itemId}
                                            </td>
                                            <td className="table-col-input text-align-left">
                                                {
                                                    <input
                                                        className="input--table input--inherit-color no-arrows input--text-align--left"
                                                        onClick={null}
                                                        value={facilityOrderTemplateItem.templateQuantity}
                                                        defaultValue={facilityOrderTemplateItem.templateQuantity}
                                                        disabled={true}
                                                    />
                                                }
                                            </td>
                                            <td className="table-col-input">
                                                <input
                                                    className="input--table input--inherit-color no-arrows input--text-align--left"
                                                    onClick={null}
                                                    value={facilityOrderTemplateItem.note}
                                                    defaultValue={facilityOrderTemplateItem.note}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        }
                    </table>
                </div>
            </div>
            <BaasicModal modalParams={facilityOrderTemplateMissingDocumentNoteModal}>
                <FacilityOrderTemplateMissingDocumentNoteModal />
            </BaasicModal>
        </Content>
    )
}

FacilityMissingDocsEditTemplate.propTypes = {
    facilityMissingDocsEditViewStore: PropTypes.object.isRequired,
};

export default defaultTemplate(FacilityMissingDocsEditTemplate);